export enum LocalDropdownNotificationType {
  ORG_ADMIN_USER_DROPDOWN_ATS_CTA = 'ORG_ADMIN_USER_DROPDOWN_ATS_CTA',
}
